export default "__VITE_ASSET__CCiPkasI__"